/**
 * TanStack Query is a cache and synchronisation layer, not a source of truth
 * (docs/16 section 7.0). Discarding this cache must cost nothing but a round trip.
 */
import type { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { ApiError } from '../../api/errors'

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: true,
            retry: (failureCount, error) => {
              // Reads retry twice on transport or server faults. A 4xx is an
              // answer, not a blip, so it is never retried.
              if (error instanceof ApiError) {
                if (error.kind === 'offline' || error.kind === 'server') return failureCount < 2
                return false
              }
              return failureCount < 2
            },
          },
          mutations: { retry: false },
        },
      }),
  )
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
